export const ROLE = {
  STUDENT: 'student',
  EMPLOYER: 'employer',
}
